import dashboardServices from '../../../services/notisphere/dashboard'
import { RECALL_CLASSIFICATIONS, THRESHOLD_COLOR_STATUS } from '../../../misc/commons'
import orgService from '../../../services/notisphere/organization'

export default {
    data() {
        return {
            status: 'OPEN',
            supplierOrgId: null,
            listSupplier: [],
            perPage: 12,
            perPageEmit: 12,
            currentPage: 1,
            totalItems: null,
            items: [],
            recall_classifications: RECALL_CLASSIFICATIONS,
            threshold_color_status: THRESHOLD_COLOR_STATUS,
            minHeight: {
                meta: 0,
                title: 0,
                ack: 0,
                metric: 0,
            },
            loading: false,
            loadingMore: false,
            allLoaded: false,
        }
    },
    created() {
        if (this._checkPermissions(['Notisphere_ViewDashboard'])){
            this.currentPage = 1
            this.items = []
            this.allLoaded = false
            this.findSupplier()
            this.findRecallsCard()
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
        'supplierOrgId': function() {
            this.currentPage = 1
            this.items = []
            this.allLoaded = false
            this.findRecallsCard({ append: false })
        }
    },
    methods: {
        findSupplier() {
            orgService.findCreatorMeta().then(resp => {
                this.listSupplier = resp.data.d
            })
        },
        findRecallsCard({ append = false } = {}) {
            if (this.loading || this.allLoaded) return
            if (append) {
                this.loadingMore = true
            } else {
                this.loading = true
            }
            dashboardServices.findRecallsCard({
                pageNumber: this.currentPage,
                pageSize: this.perPage,
                sortField: null,
                sortDirection: null,
                status: this.status,
                supplierOrgId: this.supplierOrgId,
                stopDefaultLoader: append
            }).then(resp => {
                if (!resp.error){
                    let newItems = resp.data.d.c
                    this.items.forEach(el => {
                        el.indicator = Math.round(el.total > 0 ? el.completed / el.total * 100 : 0)
                    })
                    this.totalItems = resp.data.d.t
                    this.$nextTick(()=>{
                        this.calcHeight()
                    })
                    if (append) {
                        this.items = this.items.concat(newItems)
                    } else {
                        this.items = newItems
                    }
                    if (this.items.length >= this.totalItems) {
                        this.allLoaded = true
                    }
                }
            }).finally(() => {
                if (append) {
                    this.loadingMore = false
                } else {
                    this.loading = false
                }
            })
        },
        requestFetchData() {
            //error on server mode ( when not in page 1 and make filter, it will emit twice the request) => set timeout
            if (this.timer2) {
                clearTimeout(this.timer2)
                this.timer2 = null
            }
            this.timer2 = setTimeout(() => {
                this.findRecallsCard()
            }, 5)
        },
        statusChange(status) {
            this.status = status
            this.currentPage = 1
            this.items = []
            this.allLoaded = false
            this.findRecallsCard({ append: false })
        },
        selectPerPage(perPage) {
            this.perPage = perPage
            this.perPageEmit = perPage
        },
        supplierChange() {
            this.findRecallsCard()
        },
        isActiveStatus(status) {
            return this.status == status ? 'btn btn-primary' : 'btn btn-secondary'
        },
        viewRecall(item) {
            if (item.allow_access == true && this._checkPermissions(['Notisphere_ManageRecalls'])){
                this.$router.push({ name: 'noti_RecallView', params: { id: item.communicationId } })
            }
        },
        calcHeight() {
            let maxHeight = (type) => {
                var maxheight = 0
                for (const prop in this.$refs) {
                    for (let i = 0; i < this.items.length; i++) {
                        if (prop == type+i) {
                            var height = this.$refs[prop][0].clientHeight
                            maxheight = maxheight <= height ? height : maxheight
                        }
                    }
                }
                return maxheight
            }

            this.minHeight = {
                meta: maxHeight('meta'),
                title: maxHeight('title'),
                ack: Math.max(maxHeight('ack'), maxHeight('notack')),
                metric: Math.max(maxHeight('metric1'), maxHeight('metric2'), maxHeight('metric3')),
            }
        },
        handleScroll() {
            const scrollY = window.scrollY
            const visibleHeight = window.innerHeight
            const totalHeight = document.documentElement.scrollHeight

            const cardRowHeight = 250
            const triggerDistance = cardRowHeight * 2
            if (scrollY + visibleHeight >= totalHeight - triggerDistance) {
                if (!this.loading && !this.loadingMore && !this.allLoaded) {
                    this.currentPage += 1
                    this.findRecallsCard({ append: true })
                }
            }
        }
    }
}